var formatter = new Intl.NumberFormat('es');
var formatterDigits = new Intl.NumberFormat('es', { minimumFractionDigits: 2 });

Chart.defaults.global.defaultFontFamily = 'Lato';

Chart.pluginService.register({
    beforeRender: function (chart) {
        if (chart.config.options.showAllTooltips) {
            // create an array of tooltips
            // we can't use the chart tooltip because there is only one tooltip per chart
            chart.pluginTooltips = [];
            chart.config.data.datasets.forEach(function (dataset, i) {
                chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                    chart.pluginTooltips.push(new Chart.Tooltip({
                        _chart: chart.chart,
                        _chartInstance: chart,
                        _data: chart.data,
                        _options: chart.options.tooltips,
                        _active: [sector]
                    }, chart));
                });
            });

            // turn off normal tooltips
            chart.options.tooltips.enabled = false;
        }
    },
    afterDraw: function (chart, easing) {
        if (chart.config.options.showAllTooltips) {
            // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
            if (!chart.allTooltipsOnce) {
                if (easing !== 1)
                    return;
                chart.allTooltipsOnce = true;
            }

            // turn on tooltips
            chart.options.tooltips.enabled = true;
            Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
                tooltip.initialize();
                tooltip.update();
                // we don't actually need this since we are not animating tooltips
                tooltip.pivot();
                tooltip.transition(easing).draw();
            });
            chart.options.tooltips.enabled = false;
        }
    }
});

window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};


var configUrgenciesNivell = {
    type: 'bar',
    data: {
        labels: ["Primer nivell", "Segon nivell", "Tercer nivell", "Quart nivell", "Cinquè nivell"],
        datasets: [
        {
            label: "2019",
            backgroundColor: '#f1c79e',
            data: [657,7372,60019,58857,11629]
        },
        {
            label: "2020",
            backgroundColor: '#e38f3e',
            data: [343,5434,45361,41967,8896]
        }
    ]
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: true
        },
        scales: {
            xAxes: [{
                display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // }
                ticks: {
                    // autoSkip: false,
                    // maxRotation: 0,
                    // minRotation: 0,
                }
            }],
            yAxes: [{
                display: true,
                /*scaleLabel: {
                    display: true,
                    labelString: '€'
                },*/
                ticks: {
                    beginAtZero: true,
                    callback: function(value) {
                        // return formatter.format(value)+' €';
                        return formatter.format(value);
                    }
                }
            }]
        },
        responsive: true,
        showAllTooltips: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    // return formatterDigits.format(tooltipItem.value)+' €';
                    return formatter.format(tooltipItem.value);
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            bodyFontColor: '#f68322',
        }
    }
};

var configExternes1 = {
    type: 'horizontalBar',
    data: {
        labels: ['2019', '2020'],
        datasets: [{
            label: 'Primeres visites',
            backgroundColor: ['#ebc7a2','#e38f3e'],
            data: [
                155072,
                89513
            ]
        }, {
            label: 'Visites successives',
            backgroundColor: ['#85a9d0','#004fa5'],
            data: [
                509840,
                327739
            ]
        }]
    },
    options: {
        // elements: {
        //     rectangle: {
        //         borderWidth: 1,
        //         borderColor: "#fff"
        //     }
        // },
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        title: {
            display: false
        },
        scales: {
            xAxes: [{
                stacked: true,
                display: false
            }],
            yAxes: [{
                stacked: true,
                display: false
            }]
        }
    }
};

var configExternes2 = {
    type: 'horizontalBar',
    data: {
        labels: ['2019', '2020'],
        datasets: [{
            backgroundColor: ['#D9D9D9','#B3B3B3'],
            data: [
                268631,
                214988
            ]
        }, {
            // backgroundColor: ['#ffffff', '#ffffff'],
            backgroundColor: ['transparent', 'transparent'],
            data: [
                0,
                9800
            ]
        }]
    },
    options: {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            enabled: false
        },
        title: {
            display: false
        },
        scales: {
            xAxes: [{
                stacked: true,
                display: false
            }],
            yAxes: [{
                stacked: true,
                display: false
            }]
        }
    }
};

var configLaboratori = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                8.48,
                91.52
            ],
            backgroundColor: [
                '#004fa5',
                '#e38f3e'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        // animation: {
        //     animateScale: true,
        //     animateRotate: true,
        //     duration: 2000
        // },
    }
};

var configRadiologia = {
    type: 'line',
    data: {
        labels: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'],
        datasets: [
            {
            label: 'Radiologia 2019',
            // backgroundColor: blue,
            borderColor: '#99b9db',
            // pointStyle: ico_home,
            data: [
                851,
                1200,
                815,
                702,
                728,
                667,
                717,
                605,
                648,
                682,
                802,
                545
            ],
            borderWidth: 0,
            lineTension: 0,
            fill: false,
            pointRadius: 7.5,
            pointBackgroundColor: '#99b9db'
        },
        {
            label: 'Radiologia 2020',
            // backgroundColor: blue,
            borderColor: '#004fa5',
            // pointStyle: ico_home,
            data: [
                510,
                689,
                1200,
                1426,
                770,
                704,
                855,
                990,
                1009,
                1321,
                1363,
                1141
            ],
            borderWidth: 0,
            lineTension: 0,
            fill: false,
            pointRadius: 7.5,
            pointBackgroundColor: '#004fa5',
        }
    ]
    },
    options: {
        interaction: {
            intersect: false,
            mode: 'index',
        },
        plugins: {
            title: {
                display: true,
                text: (ctx) => 'Tooltip position mode: ' + ctx.chart.options.plugins.tooltip.position,
            },
        },
        responsive: true,
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                display: true,
                
                ticks: {
                    fontSize: 12,
                    max: 1600,
                }
            }],
            yAxes: [{
                display: true,
                ticks: {
                    padding: 30,
                    min: 0,
                    max: 1600,
                    callback: function(label, index, labels) {
                        return number_format(label, 0, ',', '.');
                    },
                }
            }]
        },
        tooltips: {

            callbacks: {
                label: function (tooltipItem) {
                    return number_format(tooltipItem.yLabel, 0, ',', '.');
                },
                title: function (tooltipItem) {
                    return;
                },
            },
        }
    }
};

var configVacunacioProfessionals = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                12,
                145,
                87,
                24,
                4268
            ],
            backgroundColor: [
                'rgb(61, 110, 179)',
                'rgb(136, 170, 210)',
                '#004fa5',
                'rgb(136, 170, 210)',
                '#004fa5'
            ],
            weight: 0.9,
            borderWidth: 0
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        // animation: {
        //     animateScale: true,
        //     animateRotate: true,
        //     duration: 2000
        // },
    }
};

var configVacunacioPacients = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                15571,
                14166,
                2362,
                12507
            ],
            backgroundColor: [
                'rgb(61, 110, 179)',
                'rgb(136, 170, 210)',
                '#004fa5',
                'rgb(136, 170, 210)'
            ],
            weight: 0.9,
            borderWidth: 0
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        // animation: {
        //     animateScale: true,
        //     animateRotate: true,
        //     duration: 2000
        // },
    }
};

var configPlantillaEquivalentMensual = {
    type: 'line',
    data: {
        labels: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '1'],
        datasets: [{
            label: 'Plantilla equivalent mensual',
            // backgroundColor: blue,
            borderColor: '#004fa5',
            // pointStyle: ico_home,
            data: [
                3575,
                3633,
                4097,
                3969,
                3730,
                3800,
                3862,
                3883,
                3843,
                3959,
                4042,
                4028
            ],
            borderWidth: 0,
            lineTension: 0,
            fill: false,
            pointRadius: 7.5,
            pointBackgroundColor: '#004fa5',
        }]
    },
    options: {
        responsive: true,
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: false,
                    // labelString: 'Month'
                },
                gridLines: {
                    display: false,
                },
                ticks: {
                    fontSize: 16,
                }
            }],
            yAxes: [{
                gridLines: {
                    drawBorder: false,
                },
                display: true,
                // scaleLabel: {
                //     display: true,
                //     labelString: 'Value'
                // }
                ticks: {
                    padding: 30,
                    max: 4200,
                    callback: function(label, index, labels) {
                        return number_format(label, 0, ',', '.');
                    },
                }
            }]
        },
        showAllTooltips: true,
        tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
                label: function (tooltipItem) {
                    return number_format(tooltipItem.yLabel, 0, ',', '.');
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            bodyFontColor: '#000000',
            // bodyFontSize: 22,
            bodyFontSize: 15,
            bodyFontStyle: 'normal',
            padding: 10
        }
    }
};

var configProjectes = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                9569519.46,
                8623366.95,
                4910003.89,
                4736691.15,
                3245015.35,
                60115.00,
                5000.00
            ],
            backgroundColor: [
                '#fa9233',
                '#0dada5',
                '#00aaf5',
                '#e5403e',
                '#97bf36',
                '#434342',
                '#cfcfcf'
            ],
            // weight: 0.9,
            borderWidth: 0,
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
    },
};

var configPubProgramme = {
    type: 'bar',
    data: {
        labels: ["Recerca clínica translacional", "Neurociències", "Epidemiologia i salut pública", "Càncer", "Informàtica biomèdica", "Total"],
        datasets: [
        {
            label: "2019",
            backgroundColor: ["#F5B3B2","#FDD3AD","#D5E5AF","#9EDEDB","#99DDFB","#a5acc2"],
            data: [318,135,258,179,29,916]
        },
        {
            label: "2020",
            backgroundColor: ["#e5403e","#fa9233","#97bf36","#0dada5","#00aaf5","#33437b"],
            data: [315,219,158,151,23,866]
        }
    ]
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // },
                ticks: {
                    maxRotation: 0,
                    minRotation: 0
                }
            }
            ],
            yAxes: [{
                display: true,
                // scaleLabel: {
                //     display: true,
                //     labelString: '€'
                // }
                ticks: {
                    callback: function(label, index, labels) {
                        return number_format(label, 0, ',', '.');
                    }
                }

            }]
        },
        responsive: true,
        showAllTooltips: false,
        tooltips: {
            //mode: 'index',
            //intersect: false,
            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            bodyFontColor: '#000000',
            bodyFontSize: 20,
            bodyFontStyle: 'normal',
            padding: 10
        }
    }
};

var configOrigenRecursos = {
    type: 'bar',
    data: {
        labels: ['2019', '2020'],
        datasets: [
            {
                label: 'Accions i campanyes',
                data: [
                    21,
                    18
                ],
                backgroundColor: '#004fa5',
            },
            {
                label: 'Amics/amigues',
                data: [
                    21,
                    14
                ],
                backgroundColor: 'rgb(61, 110, 179)',
            },
            {
                label: 'Fundacions i empreses',
                data: [
                    58,
                    68
                ],
                backgroundColor: 'rgb(136 ,170, 210)',
            },
        ],
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                stacked: true,
                gridLines: {
                    display: false,
                },
                ticks: {
                    fontSize: 16,
                }
            }],
            yAxes: [{
                stacked: true,
                drawBorder: false,
                // ticks: {
                //     display: false,
                // }

            }]
            // xAxes: [{
            //     display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // }

            // }],
            // yAxes: [{
            //     display: true,
            //     scaleLabel: {
            //         display: true,
            //         labelString: '€'
            //     }
            // }]
        },
        responsive: true,
        showAllTooltips: true,

        tooltips: {
/*            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',*/
            callbacks: {
                mode: 'label',
                label: function (tooltipItem, data) {
                    //return tooltipItem.value;
                    //return data['datasets'][0]['data'][tooltipItem['index']] + '%';
                    return data['datasets'][tooltipItem['datasetIndex']]['data'][tooltipItem['index']] + '%';
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'top',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            bodyFontColor: '#fff',
            bodyFontSize: 20,
            //bodyFontStyle: 'normal',
        }
    }
};

var configDestinacio = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                52,
                23,
                22,
                3
            ],
            backgroundColor: [
                '#e38f3e',
                '#a68262',
                '#7d5939',
                '#fccc9e'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configDonacions = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                66.4,
                33.6
            ],
            backgroundColor: [
                '#70c5c3',
                '#0084d9'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        responsive: true,
        cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        }
    }
};

var configAparicions = {
    type: 'bar',
    data: {
        labels: ['2019', '2020'],
        datasets: [{
            data: [
                363,
                901
            ],
            backgroundColor: [
                '#99b9db',
                '#004fa5'
            ]
        }],
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // }
            }],
            yAxes: [{
                display: false,
                scaleLabel: {
                    display: false,
                    // labelString: 'Value'
                }
            }]
        },
        responsive: true,
        showAllTooltips: true,
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
        }
    }
};

var configDespeses = {
    type: 'bar',
    data: {
        labels: ['2016', '2017', '2018', '2019', '2020'],
        datasets: [{
            data: [
                301,
                315,
                332,
                348,
                380
            ],
            backgroundColor: [
                '#e38f3e',
                '#e38f3e',
                '#e38f3e',
                '#e38f3e',
                '#e38f3e'
            ]
        }],
    },
    options: {
        title: {
            display: false,
        },
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                display: true,
                // scaleLabel: {
                //     display: false,
                //     labelString: 'Month'
                // }
            }],
            yAxes: [{
                display: true,
                scaleLabel: {
                    display: false,
                    // labelString: 'Value'
                },
                ticks: {
                    padding: 30,
                    min: 200,
                    max: 400
                }
            }]
        },
        responsive: true,
        showAllTooltips: true,
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    return tooltipItem.value;
                },
                title: function (tooltipItem) {
                    return;
                },
            },
            displayColors: false,
            caretSize: 0,
            xAlign: 'center',
            yAlign: 'bottom',
        }
    }
};

var configInversions1 = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                1728900,
                381422,
                91805,
                66347,
                289631
            ],
            backgroundColor: [
                'rgb(102, 149, 201)',
                'rgb(51, 114, 183)',
                'rgb(0, 79, 165)',
                'rgb(204, 220, 237)',
                'rgb(153, 185, 219)'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        },
        elements: {
            arc: {
                borderWidth: 0
            }
        }
    }
};

var configInversions2 = {
    type: 'doughnut',
    data: {
        datasets: [{
            data: [
                10053666,
                2061413,
                17150678
            ],
            backgroundColor: [
                'rgb(246, 218, 191)',
                'rgb(237, 181, 128)',
                'rgb(227, 143, 62)'
            ],
            weight: 0.9
        }],
    },
    options: {
        tooltips: {
            enabled: false
        },
        // responsive: true,
        // cutoutPercentage: 40,
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 2000
        },
        elements: {
            arc: {
                borderWidth: 0
            }
        }
    }
};

$(document).ready(function () {
    ("use strict");

    $('#chart-urgencies-nivell').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-urgencies-nivell').getContext('2d');
            window.myBar = new Chart(ctx, configUrgenciesNivell);
        },
    });

    $('#chart-externes-1').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-externes-1').getContext('2d');
            window.myHorizontalBar = new Chart(ctx, configExternes1);
        },
    });
    
    $('#chart-externes-2').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-externes-2').getContext('2d');
            window.myHorizontalBar = new Chart(ctx, configExternes2);
        },
    });

    $('#chart-laboratori').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-laboratori').getContext('2d');
            window.myDoughnut = new Chart(ctx, configLaboratori);
        },
    });

    $('#chart-radiologia').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-radiologia').getContext('2d');
            window.myLine = new Chart(ctx, configRadiologia);
        },
    });

    $('#chart-vacunacio-professionals').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-vacunacio-professionals').getContext('2d');
            window.myDoughnut = new Chart(ctx, configVacunacioProfessionals);
        },
    });
    
    $('#chart-vacunacio-pacients').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-vacunacio-pacients').getContext('2d');
            window.myDoughnut = new Chart(ctx, configVacunacioPacients);
        },
    });

    $('#chart-plantilla-equivalent').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-plantilla-equivalent').getContext('2d');
            window.myLine = new Chart(ctx, configPlantillaEquivalentMensual);
        },
    });

    $('#chart-projectes').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-projectes').getContext('2d');
            window.myDoughnut = new Chart(ctx, configProjectes);
        },
    });

    $('#chart-pub-programme').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-pub-programme').getContext('2d');
            window.myBar = new Chart(ctx, configPubProgramme);
        },
    });

    $('#chart-origen-recursos').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-origen-recursos').getContext('2d');
            window.myDoughnut = new Chart(ctx, configOrigenRecursos);
        },
    });

    $('#chart-destinacio').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-destinacio').getContext('2d');
            window.myDoughnut = new Chart(ctx, configDestinacio);
        },
    });

     $('#chart-donacions').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-donacions').getContext('2d');
            window.myDoughnut = new Chart(ctx, configDonacions);
        },
    });

    $('#chart-aparicions').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-aparicions').getContext('2d');
            window.myBar = new Chart(ctx, configAparicions);
        },
    });

    $('#chart-despeses').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-despeses').getContext('2d');
            window.myBar = new Chart(ctx, configDespeses);
        },
    });

    $('#chart-inversions-1').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-inversions-1').getContext('2d');
            window.myDoughnut = new Chart(ctx, configInversions1);
        },
    });
    
    $('#chart-inversions-2').parent().viewportChecker({
        callbackFunction: function () {
            var ctx = document.getElementById('chart-inversions-2').getContext('2d');
            window.myDoughnut = new Chart(ctx, configInversions2);
        },
    });

});


function number_format(number, decimals, dec_point, thousands_sep) {
    // *     example: number_format(1234.56, 2, ',', ' ');
    // *     return: '1 234,56'
    number = (number + '').replace(',', '').replace(' ', '');
    var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}